/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TestprofielDto } from '../models/testprofiel-dto';

@Injectable({
  providedIn: 'root',
})
export class TestprofielApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTestprofielen
   */
  static readonly GetTestprofielenPath = '/api/Testprofiel/get-testprofielen';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTestprofielen$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTestprofielen$Plain$Response(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<Array<TestprofielDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TestprofielApiService.GetTestprofielenPath, 'get');
    if (params) {
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TestprofielDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTestprofielen$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTestprofielen$Plain(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<Array<TestprofielDto>> {

    return this.getTestprofielen$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TestprofielDto>>) => r.body as Array<TestprofielDto>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTestprofielen()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTestprofielen$Response(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<StrictHttpResponse<Array<TestprofielDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TestprofielApiService.GetTestprofielenPath, 'get');
    if (params) {
      rb.header('BaaS-Context-Frontend', params['BaaS-Context-Frontend'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TestprofielDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTestprofielen$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTestprofielen(params?: {

    /**
     * {&#x27;SecurityGuid&#x27;:&#x27;********-****-****-****-************&#x27;}
     */
    'BaaS-Context-Frontend'?: string;
  }): Observable<Array<TestprofielDto>> {

    return this.getTestprofielen$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TestprofielDto>>) => r.body as Array<TestprofielDto>)
    );
  }

}
